module.exports = __webpack_public_path__ + "static/media/image_news.9f8fbc02.png";